import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import Footer from "shared/Footer/Footer";
import Page404 from "containers/Page404/Page404";
import SiteHeader from "containers/SiteHeader";
import FooterNav from "components/FooterNav";
import useWindowSize from "hooks/useWindowResize";
import { AuthProvider } from "../providers/AuthProvider";
import { Backdrop, CircularProgress } from "@mui/material";
import { useAppSelector } from "../store/hooks";
import { ModalContainer } from "../@shared/components/Modal/components/ModalContainer";
import GalleryImages from "../@shared/components/GalleryImages";
import { PrivateRoute } from "./PrivateRoute";
import { pages, privatePages } from "./routes";

const MyRoutes = () => {
  const loaderSelector = useAppSelector(state => state.loader);
  let WIN_WIDTH = useWindowSize().width;
  if (typeof window !== "undefined") {
    WIN_WIDTH = WIN_WIDTH || window.innerWidth;
  }

  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop/>
        <SiteHeader/>

        <Routes>
          {pages.map(({ component, path }) => {
            const Component = component;
            return <Route key={path} element={<Component/>} path={path}/>;
          })}

          <Route element={<PrivateRoute/>}>
            {privatePages.map(({ component, path }) => {
              const Component = component;
              return <Route key={path} element={<Component/>} path={path}/>;
            })}
          </Route>

          <Route element={<Page404/>}/>
        </Routes>

        {WIN_WIDTH < 768 && <FooterNav/>}

        <Backdrop
          open={loaderSelector.loading}
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
          style={{
            color: 'white',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <CircularProgress color="inherit"/>
          <div className={'mt-4'}>
            {loaderSelector.message}
          </div>
        </Backdrop>
        <GalleryImages/>
        <ModalContainer/>
        <Footer/>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default MyRoutes;
